export default {
  "auth.login": "Login",
  "auth.register": "Sign Up",
  "auth.email": "Email Address",
  "auth.password": "Password",
  "auth.logout": "Logout",
  "auth.loginFailed": "Login failed",
  "auth.registerFailed": "User registration failed",
  "nav.dashboard": "Evaluation Dashboard",
  "nav.activeEvaluations": "Active Evaluations",
  "nav.completedEvaluations": "Completed Evaluations",
  "nav.createNew": "Create New Evaluation",
  "nav.projectMerge": "Project Merge",
  "nav.share": "Share Settings",
  "nav.copy": "Copy",
  "nav.delete": "Delete",
  "nav.settings": "Settings",
  "menu.language": "Language Settings",
  "menu.colorPalette": "Color Palette",
  "status.inProgress": "In Progress",
  "status.completed": "Completed",
  "status.untitled": "Untitled Evaluation",
  "stats.subjects": "Subjects",
  "stats.criteria": "Criteria",
  "stats.progress": "Progress",
  "step.criteriaExtraction": "Criteria Extraction",
  "step.comparison": "Let's arrange them in order of quality",
  "step.subjectRegistration": "Subject Registration",
  "form.evaluationPolicy": "Evaluation Policy",
  "form.policyDescription": "Evaluation policy and key focus points",
  "form.policyPlaceholder": "Example: Emphasize logical structure and evaluate creativity and originality",
  "btn.aiExtraction": "AI Criteria Extraction",
  "btn.manualAdd": "Add Criteria Manually",
  "btn.next": "Next",
  "btn.back": "Back",
  "plan.free": "Free Plan",
  "plan.professional": "Professional",
  "plan.business": "Business",
  "plan.school": "School",
  "plan.unlimitedProjects": "Unlimited Projects",
  "plan.prioritySupport": "Priority Support",
  "plan.dataExport": "Data Export",
  "plan.monthlyRenewal": "Monthly auto-renewal",
  "plan.cancelAnytime": "Cancel anytime",
  "plan.paymentFailed": "Payment initiation failed",
  "confirm.delete": "Are you sure you want to delete? This action cannot be undone",
  "alert.appUpdate": "Application update detected",
  "alert.projectLimit": "You have reached the limit for creating evaluation projects",
  "common.loading": "Loading...",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.error": "Error",
  "common.success": "Success",
  "common.initializing": "Initializing application...",
  "common.connecting": "Connecting...",
  "common.processing": "Processing...",
  "common.required": "Required",
  "common.close": "Close",
  "common.preview": "Preview",
  "common.edit": "Edit",
  "common.details": "Details",
  "common.position": "Position",
  "common.rank": "Rank",
  "common.placed": "Placed",
  "common.characters": "characters",
  "common.items": "items",
  "common.folders": "Folders",
  "common.folder": "Folder",
  "common.files": "Files",
  "common.openInNewTab": "Open in new tab",
  "common.next": "Next",
  "common.prev": "Previous",
  "date.today": "Today",
  "date.yesterday": "Yesterday",
  "date.thisWeek": "This Week",
  "date.lastWeek": "Last Week",
  "error.dashboardLoad": "Dashboard loading error",
  "error.serverUnavailable": "Cannot connect to server. Please try again later",
  "error.evaluationLimit": "Failed to check evaluation limit",
  "error.loadingData": "Loading error",
  "error.copyFailed": "Copy error",
  "error.deleteFailed": "Failed to delete",
  "error.copyProcess": "An error occurred during the copy process",
  "error.deleteProcess": "An error occurred during the delete process",
  "error.sharingUpdate": "Failed to update sharing settings",
  "msg.loadingDashboard": "Loading dashboard...",
  "msg.retry": "Retry",
  "msg.projectLimitReached": "You have reached the evaluation project creation limit",
  "msg.upgradeToProPlan": "Please upgrade to PRO plan",
  "msg.cannotCreateProject": "Cannot create evaluation project",
  "msg.freeLastProject": "Free plan allows up to 1 evaluation project. This is your last available slot.",
  "msg.untitledProject": "Untitled Evaluation Project",
  "msg.welcome": "Welcome",
  "msg.welcomeWithName": "Welcome, {{name}}",
  "msg.created": "Created",
  "msg.updated": "Updated",
  "msg.completed": "completed",
  "copy.title": "Creating a copy of \"{{title}}\"",
  "copy.newTitle": "Enter a new title (leave blank for \"Original Title (Copy)\")",
  "progress.completed": "completed",
  "googleDrive.title": "Import from Google Drive",
  "googleDrive.connect": "Connect to Google Drive",
  "googleDrive.description": "To import evaluation targets from Google Drive in bulk, please sign in with your Google account first.",
  "googleDrive.signIn": "Sign in with Google account",
  "googleDrive.myDrive": "My Drive",
  "googleDrive.emptyFolder": "This folder is empty",
  "googleDrive.filesSelected": " files selected",
  "googleDrive.importSelected": "Import selected files",
  "googleDrive.searchPlaceholder": "Search files...",
  "googleDrive.searchResults": "Search results",
  "googleDrive.noSearchResults": "No files found matching your search",
  "googleDrive.allTypes": "All types",
  "googleDrive.documents": "Documents",
  "googleDrive.spreadsheets": "Spreadsheets",
  "googleDrive.presentations": "Presentations",
  "googleDrive.sortByName": "Sort by name",
  "googleDrive.sortByModified": "Sort by modified",
  "googleDrive.selectAll": "Select all",
  "googleDrive.clearSelection": "Clear selection",
  "modal.closeModal": "Close modal",
  "dashboard.projectLimitReached": "You have reached the limit for creating evaluation projects ({{count}} projects). Please upgrade to PRO plan.",
  "dashboard.cannotCreateProject": "Cannot create evaluation project.",
  "dashboard.freeLastProject": "Free plan allows up to 1 evaluation project. This is your last available slot.",
  "dashboard.evaluationLimitCheckFailed": "Failed to check evaluation limit.",
  "dashboard.loadingError": "Loading error: {{message}}",
  "dashboard.copyError": "Copy error: {{message}}",
  "dashboard.copyProcessError": "An error occurred during the copy process",
  "dashboard.deleteError": "Delete error: {{message}}",
  "dashboard.deleteProcessError": "An error occurred during the delete process",
  "dashboard.shareSettingsUpdateFailed": "Failed to update sharing settings",
  "dashboard.copyProjectTitle": "Creating a copy of \"{{title}}\".",
  "dashboard.copyProjectPrompt": "Enter a new title (leave blank for \"Original Title (Copy)\"):",
  "dashboard.deleteConfirm": "Delete \"{{title}}\"? This action cannot be undone.",
  "dashboard.statusUnknown": "Unknown",
  "dashboard.collaborators": "{{count}} collaborators",
  "dashboard.menu": "Menu",
  "dashboard.shareSettings": "Share settings",
  "dashboard.copy": "Copy",
  "dashboard.delete": "Delete",
  "dashboard.subjects": "Subjects",
  "dashboard.criteria": "Criteria",
  "dashboard.progress": "Progress",
  "dashboard.completed": "Completed",
  "dashboard.created": "Created:",
  "dashboard.updated": "Updated:",
  "dashboard.loadingDashboard": "Loading dashboard...",
  "dashboard.retry": "Retry",
  "dashboard.title": "Evaluation Dashboard",
  "dashboard.projectMerge": "Project Integration",
  "dashboard.createNew": "Create new evaluation",
  "dashboard.inProgressTab": "In progress evaluations",
  "dashboard.completedTab": "Completed evaluations",
  "dashboard.noInProgress": "No in-progress evaluations",
  "dashboard.noInProgressDesc": "Let's start by creating a new evaluation.",
  "dashboard.noCompleted": "No completed evaluations",
  "dashboard.noCompletedDesc": "Completed evaluations will appear here.",
  "dashboard.untitledProject": "Untitled evaluation project",
  "dashboard.sharing": "Sharing",
  "billing.paymentCompleted": "Payment Completed",
  "billing.subscriptionCompleted": "Subscription registration completed. Thank you for using our service!",
  "billing.paymentCanceled": "Payment was canceled. Please try again or contact us.",
  "settings.backToDashboard": "← Back to Dashboard",
  "userSettings.title": "User Settings",
  "userSettings.description": "Manage your account information and security settings.",
  "userSettings.basicInfo": "Basic Information",
  "userSettings.username": "Username",
  "userSettings.usernamePlaceholder": "Enter username",
  "userSettings.email": "Email Address",
  "userSettings.emailPlaceholder": "example@domain.com",
  "userSettings.displayName": "Display Name",
  "userSettings.displayNamePlaceholder": "Enter display name (optional)",
  "userSettings.displayNameHelp": "Name displayed to other users.",
  "userSettings.saving": "Saving...",
  "userSettings.saveSettings": "Save Settings",
  "userSettings.securitySettings": "Security Settings",
  "userSettings.securityMode": "Security Mode",
  "userSettings.securityModeDescription": "Enable data encryption to protect your privacy.",
  "userSettings.securityOn": "Enabled",
  "userSettings.securityOff": "Disabled",
  "userSettings.securityCode": "Security Code",
  "userSettings.hide": "Hide",
  "userSettings.show": "Show",
  "userSettings.encryptionCode": "Encryption Code",
  "userSettings.recoveryCode": "Recovery Code",
  "userSettings.copy": "Copy",
  "userSettings.generateNewKeys": "Generate New Keys",
  "userSettings.manualKeyInput": "Manual Key Input",
  "userSettings.viewSharedData": "View Shared Data",
  "userSettings.viewSharedDataDescription": "Input keys to view encrypted data shared by other users.",
  "userSettings.inputEncryptionKey": "Input Encryption Key",
  "userSettings.manualKeyTitle": "Manual Encryption Key Input",
  "userSettings.manualKeyDescription": "Enter the shared encryption key pair.",
  "userSettings.publicKey": "Public Key",
  "userSettings.publicKeyPlaceholder": "Enter public key",
  "userSettings.privateKey": "Private Key",
  "userSettings.privateKeyPlaceholder": "Enter private key",
  "userSettings.keyWarning": "Warning:",
  "userSettings.keyWarningText": "These keys are confidential. Store them in a secure location.",
  "userSettings.setKeys": "Set Keys",
  "userSettings.requiredFieldsError": "Username and email address are required fields.",
  "userSettings.enableSecurityModeConfirm": "Enable security mode? Data encryption will begin.",
  "userSettings.securityModeEnabled": "Security mode has been enabled.",
  "userSettings.securityModeDisabled": "Security mode has been disabled.",
  "userSettings.generateNewKeysConfirm": "Generate new keys? Existing keys will become invalid.",
  "userSettings.newKeysGenerated": "New keys have been generated.",
  "userSettings.bothKeysRequired": "Both public and private keys are required.",
  "userSettings.invalidPublicKeyFormat": "Public key format is invalid.",
  "userSettings.invalidPrivateKeyFormat": "Private key format is invalid.",
  "userSettings.keysSet": "Keys have been set.",
  "userSettings.keySetError": "Error occurred while setting keys.",
  "userSettings.copiedToClipboard": "Copied to clipboard.",
  "userSettings.copyFailed": "Failed to copy.",
  "billing.currentPlan": "Current Plan",
  "billing.status.developerAccess": "Developer Access",
  "billing.status.active": "Active",
  "billing.status.free": "Free",
  "billing.nextRenewalDate": "Next Renewal Date",
  "billing.autoRenewalNote": "(will be automatically charged)",
  "billing.expiresAt": "Expires At",
  "billing.cancelNotice": "This subscription will be cancelled at the end of the current period.",
  "billing.cancelSubscription": "Cancel Subscription",
  "billing.cancelSubscriptionConfirm": "Cancel subscription? It will be cancelled at the end of the current period.",
  "billing.cancelSubscriptionSuccess": "Subscription cancellation has been processed. It will be cancelled at the end of the current period.",
  "billing.cancelSubscriptionFailed": "Failed to cancel.",
  "billing.forIndividual": "(For Individual)",
  "billing.forBusiness": "(For Business)",
  "billing.forSchool": "(For School)",
  "billing.free": "Free",
  "billing.month": "month",
  "billing.year": "year",
  "billing.features": "Features",
  "billing.upgrade": "Upgrade",
  "billing.customQuote": "Custom Quote",
  "billing.flexibleCustomization": "Flexible Customization Support",
  "billing.educationalDiscount": "Educational Institution Special Pricing",
  "billing.requestCorporateQuote": "Request Corporate Quote",
  "billing.requestAcademicQuote": "Request Academic Quote",
  "billing.aboutBilling": "About Billing",
  "billing.autoRenewal": "Auto Renewal",
  "billing.autoRenewalDescription": "Monthly plans are automatically renewed on the same day each month",
  "billing.nextRenewalDateDescription": "Current subscribers can check in the \"Current Plan\" section above",
  "billing.cancellation": "Cancellation",
  "billing.cancellationDescription": "Can be cancelled anytime, service will stop at the end of the current period",
  "billing.payment": "Payment",
  "billing.paymentDescription": "We use Stripe's secure payment system",
  "billing.receipt": "Receipt",
  "billing.receiptDescription": "Automatically sent to email after payment completion",
  "billing.aiUsageLimitation": "*Usage may be limited based on other users' activity",
  "billing.enterprise": "For Business",
  "billing.education": "For Education",
  "billing.feature.limited_projects": "Evaluation Projects: Up to 1",
  "billing.feature.unlimited_projects": "Evaluation Projects: Unlimited",
  "billing.feature.unlimited_collaborators": "Collaborators: Unlimited",
  "billing.feature.basic_rubric": "Rubric Features",
  "billing.feature.advanced_rubric": "Rubric Features (Full)",
  "billing.feature.ai_assistance": "AI Assistance (Coming Soon)",
  "billing.feature.priority_support": "Email Support",
  "billing.feature.data_export": "CSV Export (50/day)",
  "billing.feature.custom_templates": "Custom Templates (Coming Soon)",
  "billing.feature.pdf_export": "PDF Export (Unlimited)",
  "billing.feature.limited_pdf_export": "PDF Export (5/day)",
  "billing.feature.no_csv_export": "CSV Export: Not Available",
  "billing.feature.sharing_reception": "Receive Sharing Invitations",
  "billing.feature.allProfessionalFeatures": "All Professional Plan Features",
  "billing.feature.unlimitedUsers": "Unlimited Number of Users",
  "billing.feature.dedicatedSupportAgent": "Dedicated Support Agent",
  "billing.feature.customIntegrationAPI": "Custom Integration & API Development",
  "billing.feature.customBranding": "Custom Branding Support",
  "billing.feature.singleSignOn": "Single Sign-On (SSO)",
  "billing.feature.auditLogSecurity": "Audit Log & Security Features",
  "billing.feature.onPremiseDeployment": "On-Premise Deployment Support",
  "billing.feature.trainingImplementationSupport": "Training & Implementation Support",
  "billing.feature.unlimitedStudentFacultyAccounts": "Unlimited Student & Faculty Accounts",
  "billing.feature.educationalInstitutionSpecialPricing": "Educational Institution Special Pricing",
  "billing.feature.classroomPracticalTemplates": "Classroom & Practical Templates",
  "billing.feature.gradeManagementSystemIntegration": "Grade Management System Integration",
  "billing.feature.learningAnalyticsReporting": "Learning Analytics & Reporting",
  "billing.feature.parentGuardianSharingFeature": "Parent & Guardian Sharing Feature",
  "billing.feature.educationalInstitutionDedicatedSupport": "Educational Institution Dedicated Support",
  "billing.feature.implementationTrainingTeacherTraining": "Implementation Training & Teacher Training",
  "quote.title": "Enterprise Plan Quote Request",
  "quote.submit": "Request Quote",
  "quote.sections.contactInfo": "Contact Information",
  "quote.sections.usagePlan": "Usage Plan",
  "quote.sections.budgetRequirements": "Budget & Requirements",
  "quote.fields.name": "Name",
  "quote.fields.position": "Position",
  "quote.fields.phone": "Phone Number",
  "quote.fields.expectedUsers": "Expected Number of Users",
  "quote.fields.timeline": "Implementation Timeline",
  "quote.fields.useCase": "Use Case",
  "quote.fields.currentSolution": "Current Evaluation Method/Tool",
  "quote.fields.budget": "Budget Range",
  "quote.fields.requirements": "Required Features/Requirements",
  "quote.fields.message": "Additional Requests/Questions",
  "quote.placeholders.currentSolution": "Please describe any current evaluation methods or tools you are using",
  "quote.placeholders.message": "Please let us know if you have any additional requests or questions",
  "quote.timeline.immediate": "Immediately",
  "quote.timeline.oneMonth": "Within 1 month",
  "quote.timeline.threeMonths": "Within 3 months",
  "quote.timeline.sixMonths": "Within 6 months",
  "quote.timeline.oneYear": "Within 1 year",
  "quote.timeline.undecided": "Undecided",
  "quote.success.title": "Quote request received",
  "quote.error.submitFailed": "Failed to submit quote request",
  "quote.error.submitFailedRetry": "Failed to submit quote request. Please try again later.",
  "common.pleaseSelect": "Please select",
  "common.other": "Other",
  "common.submitting": "Submitting...",
  "quote.corporate.subtitle": "For Corporations",
  "quote.corporate.description": "We offer customizable enterprise solutions tailored to your company's needs. Please fill out the form below and feel free to contact us.",
  "quote.corporate.sections.companyInfo": "Company Information",
  "quote.corporate.fields.companyName": "Company Name",
  "quote.corporate.fields.department": "Department",
  "quote.corporate.userCounts.small": "10-50 users",
  "quote.corporate.userCounts.medium": "51-100 users",
  "quote.corporate.userCounts.large": "101-300 users",
  "quote.corporate.userCounts.xlarge": "301-500 users",
  "quote.corporate.userCounts.xxlarge": "501-1,000 users",
  "quote.corporate.userCounts.enterprise": "1,000+ users",
  "quote.corporate.budget.under500k": "Under $5,000/month",
  "quote.corporate.budget.500k1m": "$5,000-$10,000/month",
  "quote.corporate.budget.1m3m": "$10,000-$30,000/month",
  "quote.corporate.budget.3m5m": "$30,000-$50,000/month",
  "quote.corporate.budget.over5m": "Over $50,000/month",
  "quote.corporate.placeholders.useCase": "e.g., internal evaluation system, recruitment interview assessment, training effectiveness measurement",
  "quote.corporate.formNote": "The information you provide will be managed appropriately in accordance with our privacy policy.",
  "quote.success.corporate.message": "Thank you for your request. Our representative will contact you within 2 business days.",
  "quote.corporate.requirements.sso": "Single Sign-On (SSO)",
  "quote.corporate.requirements.activeDirectory": "Active Directory Integration",
  "quote.corporate.requirements.customBranding": "Custom Branding",
  "quote.corporate.requirements.dedicatedServer": "Dedicated Server/On-Premise Deployment",
  "quote.corporate.requirements.apiIntegration": "API Integration/Custom Integration",
  "quote.corporate.requirements.auditLogs": "Audit Logs/Security Features",
  "quote.corporate.requirements.multilingual": "Multi-language Support",
  "quote.corporate.requirements.support24": "24/7 Support",
  "quote.corporate.requirements.training": "Implementation Training",
  "quote.corporate.requirements.dataMigration": "Data Migration Support",
  "quote.academic.subtitle": "For Schools & Educational Institutions",
  "quote.academic.description": "We offer solutions specifically tailored to educational institutions. Special pricing and educational-specific feature customizations are available.",
  "quote.academic.sections.institutionInfo": "Educational Institution Information",
  "quote.academic.fields.institutionName": "School/Institution Name",
  "quote.academic.fields.institutionType": "Institution Type",
  "quote.academic.fields.department": "Faculty/Department",
  "quote.academic.fields.positionTitle": "Position/Title",
  "quote.academic.fields.expectedUsers": "Expected Number of Users (Faculty/Staff)",
  "quote.academic.fields.studentCount": "Number of Students",
  "quote.academic.fields.currentSolution": "Current Evaluation Method/System",
  "quote.academic.fields.budgetAnnual": "Budget Range (Annual)",
  "quote.academic.institutionTypes.university": "University",
  "quote.academic.institutionTypes.college": "College/Community College",
  "quote.academic.institutionTypes.highSchool": "High School",
  "quote.academic.institutionTypes.juniorHigh": "Middle School",
  "quote.academic.institutionTypes.elementary": "Elementary School",
  "quote.academic.institutionTypes.vocational": "Vocational Training School",
  "quote.academic.userCounts.small": "5-20 users",
  "quote.academic.userCounts.medium": "21-50 users",
  "quote.academic.userCounts.large": "51-100 users",
  "quote.academic.userCounts.xlarge": "101-300 users",
  "quote.academic.userCounts.xxlarge": "301-500 users",
  "quote.academic.userCounts.enterprise": "500+ users",
  "quote.academic.studentCounts.under100": "Under 100",
  "quote.academic.studentCounts.small": "100-500",
  "quote.academic.studentCounts.medium": "501-1,000",
  "quote.academic.studentCounts.large": "1,001-3,000",
  "quote.academic.studentCounts.xlarge": "3,001-10,000",
  "quote.academic.studentCounts.xxlarge": "10,000+",
  "quote.academic.timeline.nextSemester": "Next Semester",
  "quote.academic.timeline.nextYear": "Next Academic Year",
  "quote.academic.budget.under1m": "Under $10,000",
  "quote.academic.budget.1m3m": "$10,000-$30,000",
  "quote.academic.budget.3m5m": "$30,000-$50,000",
  "quote.academic.budget.5m10m": "$50,000-$100,000",
  "quote.academic.budget.over10m": "$100,000+",
  "quote.academic.placeholders.position": "e.g., Professor, Assistant Professor, Administrative Staff",
  "quote.academic.placeholders.useCase": "e.g., student evaluation, practical/skills assessment, faculty training, course evaluation",
  "quote.academic.placeholders.currentSolution": "Please describe any current evaluation methods or systems you are using",
  "quote.academic.placeholders.message": "Please let us know if you have any specific educational institution requirements or questions",
  "quote.academic.formNote": "The information you provide will be managed appropriately in accordance with our privacy policy.",
  "quote.success.academic.message": "Thank you for your request. Our educational institution specialist will contact you within 2 business days.",
  "quote.academic.requirements.lmsIntegration": "Learning Management System (LMS) Integration",
  "quote.academic.requirements.gradeManagement": "Grade Management System Integration",
  "quote.academic.requirements.studentPortal": "Student Portal Integration",
  "quote.academic.requirements.parentSharing": "Parent/Guardian Sharing Features",
  "quote.academic.requirements.courseTemplates": "Course/Practical Templates",
  "quote.academic.requirements.learningAnalytics": "Learning Analytics/Reporting",
  "quote.academic.requirements.multilingualEng": "Multi-language Support (English, etc.)",
  "quote.academic.requirements.teacherTraining": "Teacher Training",
  "quote.academic.requirements.implementationSupport": "Implementation Support/Training",

  // Report Generation
  "report.title": "Report Generation",
  "report.evaluationNotice": "Evaluation Report",
  "report.evaluationDate": "Evaluation Date",
  "report.criteriaEvaluation": "Criteria-based Evaluation",
  "report.overallEvaluation": "Overall Evaluation",
  "report.comments": "Comments",
  "report.commentsPlaceholder": "Enter details or comments...",
  "report.commentsEmpty": "No details entered",
  "report.editComments": "Edit Details",
  "report.showPreview": "Show Preview",
  "report.hidePreview": "Hide Preview",
  "report.preview": "Preview",
  "report.criterionColumn": "Criterion",
  "report.gradeColumn": "Grade",
  "report.rankColumn": "Rank",
  "report.descriptionColumn": "Description",
  "report.nthGrade": "Grade {{grade}}",
  "report.topPercentile": "Top {{percent}}%",
  "report.rankFormat": "{{position}}/{{total}}",
  "report.noDescription": "-",
  "report.personalEvaluation": "Personal Evaluation",
  "report.groupAverage": "Group Average",
  "report.summary": "Summary",
  "report.enableOverallEvaluation": "Enable Overall Evaluation",
  "report.disableOverallEvaluation": "Disable Overall Evaluation",
  "report.pointsFormat": "{{score}} points / {{maxScore}} points",
  "report.percentageFormat": "({{percentage}}%)",
  "report.configureWeights": "Configure Weights",
  "report.footerNote": "※ This evaluation shows both criterion-referenced and norm-referenced assessments.",
  "report.rubricTitle": "Evaluation Criteria (Rubric)",
  "report.noRubric": "No rubric has been generated",
  "report.noSubjects": "No evaluation subjects have been registered.",
  "report.print": "Print",
  "report.downloadPdf": "Download PDF",
  "report.downloadAllPdf": "Download All {{count}} as PDF",
  "report.allEvaluations": "All Evaluation Results",
  "report.generatingPdf": "Generating PDF...",
  "report.downloadPdfLimitReached": "Download PDF (Limit Reached)",
  "report.pdfExportLimit": "PDF export limit ({{count}} files per day) reached. Please upgrade to {{planName}} or try again tomorrow.",
  "report.pdfExportError": "PDF export is not available.",
  "report.pdfGenerationFailed": "PDF generation failed.",
  "report.pdfGenerationError": "PDF generation error:",
  "report.reportCardNotFound": "Report card not found.",
  "report.pdfExportStatus": "Today's PDF exports: {{current}}/{{max}}",
  "report.pdfExportRemaining": " ({{remaining}} remaining)",
  "report.pdfExportLimitReached": "Daily export limit reached. {{planName}} offers unlimited exports.",
  "report.backToRubric": "Back to Rubric Generation",
  "autoSave.unsaved": "Unsaved",
  "autoSave.savedSecondsAgo": "Saved {{seconds}} seconds ago",
  "autoSave.savedMinutesAgo": "Saved {{minutes}} minutes ago",
  "autoSave.savedAtTime": "Saved at {{time}}",
  "autoSave.saving": "Saving...",
  "autoSave.unsavedChanges": "Unsaved changes",
  "autoSave.autoSaveOn": "Auto-save: ON",
  "plan.pro": "PRO",
  "billing.businessPrice": "$25~",
  "billing.schoolPrice": "$7~",
  "billing.pricePerMonth": "/month/person",

  // Steps
  "steps.process.ariaLabel": "Evaluation Process",
  "steps.productRegistration.title": "Register Subjects",
  "steps.productRegistration.description": "Register subjects to evaluate",
  "steps.criteriaExtraction.title": "Extract Criteria",
  "steps.criteriaExtraction.description": "Extract evaluation criteria with AI",
  "steps.comparison.title": "Comparative Evaluation",
  "steps.comparison.description": "Position relatively",
  "steps.gradeAssignment.title": "Grade Assignment",
  "steps.gradeAssignment.description": "Determine final grades",
  "steps.rubricGeneration.title": "Generate Rubric",
  "steps.rubricGeneration.description": "Create rubric with AI",
  "steps.quickEvaluation.title": "Quick Evaluation",
  "steps.quickEvaluation.description": "Complete evaluation easily",
  "steps.reportGeneration.title": "Generate Reports",
  "steps.reportGeneration.description": "Create beautiful report cards",

  // Criteria Extraction
  "criteriaExtraction.emptyState.title": "Please register evaluation subjects first",
  "criteriaExtraction.emptyState.description": "To extract criteria, you need to register evaluation subjects first.",
  "criteriaExtraction.emptyState.backButton": "Back to Subject Registration",
  "criteriaExtraction.title": "Criteria Extraction",
  "criteriaExtraction.description": "Describe what criteria you want to evaluate. AI will automatically extract evaluation criteria.",
  "criteriaExtraction.policyTitle": "Evaluation Policy & Key Points",
  "criteriaExtraction.policyDescription": "Describe specifically what criteria you want to evaluate. AI will automatically extract optimal evaluation criteria.",
  "criteriaExtraction.policyLabel": "Evaluation Policy",
  "criteriaExtraction.policyPlaceholder": "Example: Emphasize logical structure, evaluate creativity and originality, focus on feasibility, etc.",
  "criteriaExtraction.removePolicyTitle": "Remove evaluation policy {{index}}",
  "criteriaExtraction.addPolicyButton": "Add Evaluation Policy",
  "criteriaExtraction.extractButton": "Extract with AI",
  "criteriaExtraction.extractingButton": "Extracting with AI...",
  "criteriaExtraction.extractedTitle": "Extracted Evaluation Criteria",
  "criteriaExtraction.extractedSubtitle": "{{count}} evaluation criteria have been extracted. Please review and edit the content.",
  "criteriaExtraction.addCriterionButton": "Add Criterion Manually",
  "criteriaExtraction.newCriterionTitle": "New Criterion",
  "criteriaExtraction.newCriterionDescription": "Evaluate based on this criterion",
  "criteriaExtraction.generation.extracting": "Extracting evaluation criteria...",
  "criteriaExtraction.generation.extractingDescription": "AI is analyzing your input to extract relevant evaluation criteria.",
  "criteriaExtraction.successTitle": "Criteria extraction completed!",
  "criteriaExtraction.successDescription": "Review each criterion and edit as needed before proceeding to the next step.",
  "criteriaExtraction.nextButton": "To Comparative Evaluation",
  "criteriaExtraction.prevButton": "Back to Subject Registration",
  "criteriaExtraction.edit.modalTitle": "Edit Criterion ({{index}}/{{total}})",
  "criteriaExtraction.edit.titlePlaceholder": "Enter criterion name",
  "criteriaExtraction.edit.descriptionPlaceholder": "Describe this criterion",
  "criteriaExtraction.edit.save": "Save",
  "criteriaExtraction.edit.cancel": "Cancel",
  "criteriaExtraction.form.titleLabel": "Criterion Name",
  "criteriaExtraction.form.descriptionLabel": "Description",
  "criteriaExtraction.form.addDescription": "Add Description",

  // Product Registration
  "productRegistration.title": "Register Evaluation Subjects",
  "productRegistration.description": "Register subjects to evaluate (student reports, products, proposals, etc.).",
  "productRegistration.securityNotice": "🔒 Security mode is enabled. Subject names will be encrypted.",
  "productRegistration.viewToggle.form": "Form",
  "productRegistration.viewToggle.formTitle": "Form View",
  "productRegistration.viewToggle.table": "Table",
  "productRegistration.viewToggle.tableTitle": "Table View",
  "productRegistration.import.drive": "Import from Google Drive",
  "productRegistration.import.driveTitle": "Import from Google Drive",
  "productRegistration.import.driveLabel": "Import files from Google Drive",
  "productRegistration.import.csv": "Upload CSV File",
  "productRegistration.import.csvTitle": "Upload CSV File",
  "productRegistration.import.csvLabel": "Upload evaluation subjects from CSV file",
  "productRegistration.import.template": "Download CSV Template",
  "productRegistration.import.templateTitle": "Download CSV Template",
  "productRegistration.import.templateLabel": "Download CSV template file",
  "productRegistration.import.driveDetail": "Imported from Google Drive: {{fileName}}",
  "productRegistration.form.titleLabel": "Subject Name",
  "productRegistration.form.titlePlaceholder": "e.g., Report A, Proposal B, Project C",
  "productRegistration.form.titleHelp": "Enter the name of the subject to evaluate",
  "productRegistration.form.linkLabel": "Link (Optional)",
  "productRegistration.form.linkPlaceholder": "https://drive.google.com/... etc.",
  "productRegistration.form.linkHelp": "Enter URL for related materials or files if available",
  "productRegistration.form.detailLabel": "Details & Comments",
  "productRegistration.form.detailPlaceholder": "Enter details necessary for evaluation such as characteristics, content, and background information.\nExample: \"Draft version of graduation thesis, proposal for regional revitalization created by 3rd-year economics student\"",
  "productRegistration.form.detailHelp": "Please provide specific details about the content and characteristics to help evaluators assess properly",
  "productRegistration.form.addButton": "Add Subject",
  "productRegistration.list.title": "Registered Subjects ({{count}})",
  "productRegistration.list.encryptedBadge": "🔒 Encrypted",
  "productRegistration.list.encrypted": "Encrypted",
  "productRegistration.edit.titlePlaceholder": "Enter subject name",
  "productRegistration.edit.linkPlaceholder": "Enter link URL",
  "productRegistration.edit.detailPlaceholder": "Enter details & comments",
  "productRegistration.edit.save": "Save",
  "productRegistration.edit.cancel": "Cancel",
  "productRegistration.edit.modalTitle": "Edit Evaluation Subject ({{index}}/{{total}})",
  "productRegistration.preview": "Preview {{title}}",
  "productRegistration.edit": "Edit {{title}}",
  "productRegistration.delete": "Delete {{title}}",
  "productRegistration.googleDrive.importedDetail": "Imported from Google Drive: {{name}}",
  "productRegistration.csv.header1": "Subject Name",
  "productRegistration.csv.detail1": "Detailed Description",
  "productRegistration.csv.validationError": "CSV file must have reviewTitle and reviewComment columns. Please download the template and check.",
  "productRegistration.error.encryptionFailed": "Failed to encrypt subject name. Please check security settings.",
  "productRegistration.navigation.next": "To Criteria Extraction",
  "productRegistration.directRubric.title": "Create Rubric Directly",
  "productRegistration.directRubric.description": "You can also skip criteria extraction and create a rubric manually.",
  "productRegistration.directRubric.button": "Go to Manual Rubric Creation",
  "productRegistration.nextButton": "To Criteria Extraction",
  "productRegistration.error.decryptionLog": "Decryption error for subject {{index}}:",
  "productRegistration.error.decryptionDisplay": "[Decryption Error]",
  "productRegistration.error.encryptionLog": "Subject name encryption error:",
  "productRegistration.error.encryptionAlert": "Failed to encrypt subject name. Please check security settings.",
  "productRegistration.error.csvAlert": "CSV file must have reviewTitle and reviewComment columns. Please download the template and check.",
  "productRegistration.csv.exampleTitle1": "Subject Name 1",
  "productRegistration.csv.exampleDetail1": "Detailed Description 1",
  "productRegistration.csv.exampleTitle2": "Subject Name 2",
  "productRegistration.csv.exampleDetail2": "Detailed Description 2",
  "productRegistration.csv.exampleTitle3": "Subject Name 3",
  "productRegistration.csv.exampleDetail3": "Detailed Description 3",

  // Preview Modal
  "preview.title": "{{title}} - Preview",
  "preview.loading": "Loading...",
  "preview.loadError": "Load Error",
  "preview.loadErrorDetail": "Failed to load the page",
  "preview.invalidUrl": "Invalid URL",
  "preview.invalidUrlDetail": "This is not a valid URL",
  "preview.pageLoadError": "Could not load the page",
  "preview.comment": "Comment",
  "preview.commentPlaceholder": "Enter comments about this evaluation target...",

  // Comparison Evaluation
  "comparisonEvaluation.emptyState.title": "Please set evaluation subjects and criteria first",
  "comparisonEvaluation.emptyState.description": "Both evaluation subjects and criteria are required for comparative evaluation.",
  "comparisonEvaluation.emptyState.backToProducts": "Back to Subject Registration",
  "comparisonEvaluation.emptyState.backToCriteria": "Back to Criteria Extraction",
  "comparisonEvaluation.title": "Let's arrange some in order of quality",
  "comparisonEvaluation.description": "",
  "comparisonEvaluation.criterionSelector.title": "Select Evaluation Criterion",
  "comparisonEvaluation.productsPanel.title": "Evaluation Subjects",
  "comparisonEvaluation.productsPanel.hint": "Drag to position on the number line",
  "comparisonEvaluation.evaluationLine.low": "Bad",
  "comparisonEvaluation.evaluationLine.high": "Good",
  "comparisonEvaluation.evaluationLine.hint": "You can drag and reposition placed items",
  "comparisonEvaluation.progress.prefix": "Progress: ",
  "comparisonEvaluation.progress.suffix": " / {{total}} placed",
  "comparisonEvaluation.progress.completed": "✅ All evaluations completed",
  "comparisonEvaluation.options.title": "Select Placement Method",
  "comparisonEvaluation.options.description": "You can choose to place all items at once or use quick mode to place them one by one after creating the rubric.",
  "comparisonEvaluation.options.quickModeButton": "Use Quick Evaluation Mode",
  "comparisonEvaluation.options.quickModeNote": "※ Simple mode to place one by one after rubric creation",
  "comparisonEvaluation.nextButton": "To Grade Assignment",
  "comparisonEvaluation.prevButton": "Back to Criteria Extraction",

  // Grade Assignment
  "gradeAssignment.emptyState.title": "Please complete the evaluation",
  "gradeAssignment.emptyState.description": "Comparative evaluation must be completed to set grades.",
  "gradeAssignment.emptyState.backButton": "Back to Comparative Evaluation",
  "gradeAssignment.title": "Grade Assignment",
  "gradeAssignment.description": "For each criterion, drag the grade boundaries to adjust them.",
  "gradeAssignment.criterionSelector.title": "Select Criterion",
  "gradeAssignment.gradeSuffix": "grades",
  "gradeAssignment.gradeSettings.titleSuffix": " Grade Settings",
  "gradeAssignment.editGradesButton": "Edit Grades",
  "gradeAssignment.boundaries.title": "Grade Boundary Adjustment",
  "gradeAssignment.boundaries.description": "Drag the boundary lines to adjust grade ranges",
  "gradeAssignment.distribution.title": "Grade Distribution",
  "gradeAssignment.table.grade": "Grade",
  "gradeAssignment.table.count": "Count",
  "gradeAssignment.table.percentage": "Percentage",
  "gradeAssignment.table.subjects": "Evaluation Subjects",
  "gradeAssignment.table.tooltip": "Double-click to show details",
  "gradeAssignment.nextButton": "To Rubric Generation",
  "gradeAssignment.prevButton": "Back to Comparative Evaluation",
  "gradeAssignment.modal.title": "Edit Grades",
  "gradeAssignment.modal.gradeNamesTitle": "Set Grade Names",
  "gradeAssignment.modal.gradeLabel": "Grade {{index}}",
  "gradeAssignment.modal.gradePlaceholder": "Enter grade name",
  "gradeAssignment.modal.deleteButton": "Delete",
  "gradeAssignment.modal.addGradeButton": "Add Grade",
  "gradeAssignment.modal.doneButton": "Done",
  "gradeAssignment.status.notEvaluated": "Not Evaluated",
  "gradeAssignment.status.notSet": "Not Set",
  "gradeAssignment.saveSuccess": "Evaluation data saved!",
  "gradeAssignment.boundaryLabel": "{{upper}}・{{lower}} Boundary",
  "gradeAssignment.doubleClickToView": "Double-click to view details",
  "gradeAssignment.dragBoundaryHint": "Drag the boundary lines to adjust grade ranges",
  "gradeAssignment.percentAbove": "{{percent}}% and above is {{grade}}",
  "gradeAssignment.gradeNumber": "Grade {{number}}",
  "gradeAssignment.grade": "Grade",
  "rubricGeneration.emptyState.title": "Please complete grade assignment",
  "rubricGeneration.emptyState.description": "Grade assignment must be completed before generating rubrics.",
  "rubricGeneration.emptyState.backButton": "Back to Grade Assignment",
  "rubricGeneration.title": "Rubric Generation",
  "rubricGeneration.description": "Create detailed rubrics by analyzing differences between top-rated works.",
  "rubricGeneration.progress.title": "Grade Boundary Difference Analysis Progress",
  "rubricGeneration.progress.criteriaComplete": "criteria complete",
  "rubricGeneration.progress.boundaryComplete": "boundaries complete",
  "rubricGeneration.question.criterionLabel": "Criterion:",
  "rubricGeneration.question.gradeSuffix": "Grade",
  "rubricGeneration.question.moreCount": "+{{count}} more",
  "rubricGeneration.question.title": "What differences did you notice between {{upperGrade}} Grade and {{lowerGrade}} Grade works for the \"{{criterion}}\" criterion?",
  "rubricGeneration.question.placeholder": "Example: {{upperGrade}} Grade works have clear logical structure with abundant supporting data. Meanwhile, {{lowerGrade}} Grade works have good arguments but lack specific examples and persuasive power.",
  "rubricGeneration.question.addButton": "Add Difference",
  "rubricGeneration.question.recordedDifferences": "Recorded Differences:",
  "rubricGeneration.question.deleteButton": "Delete",
  "rubricGeneration.question.completeButton": "Complete This Boundary Analysis",
  "rubricGeneration.summary.title": "Grade Boundary Analysis Summary",
  "rubricGeneration.summary.boundaryTitle": "{{upperGrade}}-{{lowerGrade}} Boundary",
  "rubricGeneration.summary.differencesCount": "{{count}} differences recorded",
  "rubricGeneration.generation.generating": "Generating rubric...",
  "rubricGeneration.generation.generateButton": "Generate AI Rubric",
  "rubricGeneration.display.title": "Generated Rubric",
  "rubricGeneration.display.description": "Detailed rubric created from AI-analyzed difference information.",
  "rubricGeneration.display.regenerateButton": "Regenerate",
  "rubricGeneration.navigation.nextToQuick": "To Quick Evaluation",
  "rubricGeneration.navigation.backToGrade": "Back to Grade Assignment",
  "rubricGeneration.error.generation": "An error occurred while generating the rubric",

  // Progress Bar
  "progressBar.label": "Evaluation Progress",
  "progressBar.messages.criteriaSetup": "Setting criteria will complete 15%",
  "progressBar.messages.completed": "🎉 Evaluation completed!",
  "progressBar.messages.progress": "Products: {{products}} × Criteria: {{criteria}} = {{total}} evaluations",

  // Evaluation Header
  "evaluationHeader.placeholder": "Enter evaluation title",
  "evaluationHeader.saveTitle": "Save",
  "evaluationHeader.cancelTitle": "Cancel",
  "evaluationHeader.untitled": "Untitled Evaluation",
  "evaluationHeader.editTitle": "Edit title",

  // Draggable Product Card
  "draggableProductCard.detailsCount": "Details: {{count}} characters",
  "draggableProductCard.previewAvailable": "🔗 Preview available",
  "draggableProductCard.showPreview": "Show preview",
  "draggableProductCard.editDetails": "Edit details",
  "draggableProductCard.position": "Position: {{value}}",
  "draggableProductCard.rank": "Rank: {{value}}",
  "draggableProductCard.placed": "Placed",

  // Comparative Evaluation Quick
  "comparativeEvaluationQuick.title": "Quick Evaluation Mode",
  "comparativeEvaluationQuick.criterionSelector.title": "Select Evaluation Criterion",
  "comparativeEvaluationQuick.productsPanel.title": "Evaluation Items",
  "comparativeEvaluationQuick.productsPanel.currentlyEvaluating": "Currently evaluating:",
  "comparativeEvaluationQuick.nextButton": "Next",
  "comparativeEvaluationQuick.prevButton": "Back",
  "comparativeEvaluationQuick.grades.excellent": "Excellent",
  "comparativeEvaluationQuick.grades.good": "Good",
  "comparativeEvaluationQuick.grades.average": "Average",
  "comparativeEvaluationQuick.grades.needsImprovement": "Needs Improvement",
  "comparativeEvaluationQuick.completion.title": "Evaluation Complete",
  "comparativeEvaluationQuick.completion.subtitle": "All {{count}} items have been evaluated",
  "comparativeEvaluationQuick.completion.evaluationCount": "Items Evaluated",
  "comparativeEvaluationQuick.completion.criteriaCount": "Evaluation Criteria",
  "comparativeEvaluationQuick.completion.viewResults": "View Results",
  "comparativeEvaluationQuick.completion.detailAdjustment": "Detailed Adjustment",
  "comparativeEvaluationQuick.criterionComplete.title": "\"{{criterion}}\" Complete",
  "comparativeEvaluationQuick.criterionComplete.subtitle": "{{count}} items evaluated",
  "comparativeEvaluationQuick.criterionComplete.nextCriterion": "Next criterion: ",
  "comparativeEvaluationQuick.criterionComplete.proceedToNext": "Proceed to Next Criterion",
  "comparativeEvaluationQuick.criterionComplete.allComplete": "All criteria evaluations are complete",
  "comparativeEvaluationQuick.criterionComplete.viewResults": "View Results",
  "comparativeEvaluationQuick.empty.title": "No data to evaluate",
  "comparativeEvaluationQuick.empty.description": "Please set up products and evaluation criteria.",
  "comparativeEvaluationQuick.header.doubleClickToView": "Double-click to view details",
  "comparativeEvaluationQuick.header.progress": "{{completed}} / {{total}} complete",
  "comparativeEvaluationQuick.header.criterionProgress": "({{current}} / {{total}} criteria)",
  "comparativeEvaluationQuick.navigation.nextCriterion": "Next criterion: {{name}}",
  "comparativeEvaluationQuick.progress.remaining": "{{count}} remaining",
  "comparativeEvaluationQuick.gradeExplanation.instruction": "Click anywhere from left (D: Needs Improvement) to right (A: Excellent) to place your evaluation.",
  "comparativeEvaluationQuick.gradeExplanation.currentPosition": " Current position: {{grade}} ({{description}})",
  "comparativeEvaluationQuick.actions.switchToAllMode": "Switch to All Placement Mode",
  "comparativeEvaluationQuick.shortcuts.enterNext": "Press Enter to proceed to next criterion",
  "comparativeEvaluationQuick.shortcuts.spaceSkip": "Press Space to skip to next criterion",
  "comparativeEvaluationQuick.criterion.instruction": "Please judge the superiority or inferiority in this criterion",
  
  "csvExport.export": "Export CSV",
  
  // Evaluation Page
  "evaluation.noDataToSave": "No data to save",
  "evaluation.dataSaved": "Data saved successfully!",
  "evaluation.saveFailed": "Failed to save",
  "evaluation.saveError": "Error occurred while saving",
  "evaluation.failedKeyword": "failed",
  "evaluation.errorKeyword": "error",
  "evaluation.saving": "💾 Saving...",
  
  // Missing translations
  "evaluation.loadError": "Failed to load project",
  "evaluation.loadingProject": "Loading project...",
  "evaluation.dataRetained": " - Data is retained",
  "evaluation.errorOccurred": "An error occurred: ",
  "evaluation.currentDataRetained": " - Current data is retained",
  "evaluation.unknownError": "Unknown error",
  
  // Step guidance messages
  "evaluation.guidance.registerProducts": " Please register the products to be evaluated",
  "evaluation.guidance.completeRegistration": " Complete product registration and click 'Next'",
  "evaluation.guidance.extractCriteria": " Please extract or manually add evaluation criteria",
  "evaluation.guidance.confirmCriteria": " Review and edit criteria, then click 'Next'",
  "evaluation.guidance.placeProducts": "💡 Place at least {{count}} products for each criterion",
  "evaluation.guidance.placeMoreProducts": "💡 Place {{remaining}} more products for the '{{criterionTitle}}' criterion",
  "evaluation.guidance.comparisonComplete": " Required comparisons completed. Click 'Next' to proceed to grade assignment",
  "evaluation.guidance.setGrades": "💡 Please set grades (A, B, C, etc.) for '{{criterionTitle}}'",
  "evaluation.guidance.gradesComplete": " Grade assignment completed. Click 'Next' to generate rubric",
  "evaluation.guidance.rubricGenerated": " Rubric has been generated. Click 'Next' to proceed",
  "evaluation.guidance.generateRubric": " Please generate the rubric",
  "evaluation.guidance.startEvaluation": "💡 Let's start evaluating! Simply click to place items",
  "evaluation.guidance.progress25": "💡 Great progress! Almost halfway there ({{progress}}% complete)",
  "evaluation.guidance.progress50": "💡 Over halfway! Keep it up ({{progress}}% complete)",
  "evaluation.guidance.progress75": "💡 75% complete! The finish line is in sight",
  "evaluation.guidance.almostDone": "💡 Almost there! Only {{unplacedCount}} items left",
  "evaluation.guidance.allComplete": " All evaluations completed. Click 'Next' to generate report",
  "evaluation.guidance.downloadReport": " Please download or share the report",
  
  // Progress reminder messages
  "evaluation.reminder.continuePlacing": "💭 Continue placing products for the '{{criterionTitle}}' criterion ({{remaining}} left)",
  "evaluation.reminder.almostHalf": "💭 Let's continue evaluating '{{criterionTitle}}'. Almost halfway!",
  "evaluation.reminder.overHalf": "💭 Evaluating '{{criterionTitle}}' - over halfway done!",
  "evaluation.reminder.fewLeft": "💭 Evaluating '{{criterionTitle}}' - only {{remaining}} left!",
  
  // Security mode
  "security.modeEnabled": "Security Mode Enabled",
  
  // Footer
  "footer.privacyPolicy": "Privacy Policy",
  "footer.termsOfService": "Terms of Service",
  
  // Invitation page
  "invitation.invalid": "Invalid invitation",
  "invitation.accepted": "Invitation accepted",
  "invitation.failed": "Failed to process invitation",
  "invitation.invalidOrExpired": "Invalid or expired invitation",
  "invitation.invalidTitle": "Invalid Invitation",
  "invitation.invalidDescription": "This invitation link is invalid.",
  "invitation.backToDashboard": "Back to Dashboard",
  "invitation.acceptedTitle": "Invitation Accepted",
  "invitation.acceptedDescription": "You have successfully joined the collaboration.",
  "invitation.redirecting": "Redirecting to dashboard...",
  "invitation.goToDashboard": "Go to Dashboard",
  "invitation.title": "Collaboration Invitation",
  "invitation.description": "You have received a collaboration invitation for a project.",
  "invitation.acceptQuestion": "Would you like to accept this invitation?",
  "invitation.processing": "Processing...",
  "invitation.accept": "Accept Invitation",
  "invitation.decline": "Decline",
  "invitation.capabilitiesTitle": "Collaborator Permissions",
  "invitation.capability1": "View and edit projects",
  "invitation.capability2": "Conduct and modify evaluations",
  "invitation.capability3": "Generate and export reports",
  "invitation.capability4": "Invite other members",
  "invitation.capability5": "Change project settings",
  
  // RubricGeneration
  "rubricGeneration.generation.generatingDescription": "Analyzing criteria and products to generate optimal evaluation rubric...",
  "rubricGeneration.generation.step1": "Analyzing evaluation criteria",
  "rubricGeneration.generation.step2": "Analyzing product characteristics",
  "rubricGeneration.generation.step3": "Generating evaluation rubric",
  "rubricGeneration.criterionSelector.title": "Select Criteria",
  "rubricGeneration.display.editCellAria": "Edit cell",
  "rubricGeneration.differenceDialog.title": "Explain the Differences",
  "rubricGeneration.differenceDialog.progress": "Question {{current}} of {{total}}",
  "rubricGeneration.differenceDialog.question": "What distinguishes \"{{gradeA}}\" from \"{{gradeB}}\" for {{criterion}}?",
  "rubricGeneration.differenceDialog.hint": "Please describe the specific differences between these evaluation levels.",
  "rubricGeneration.differenceDialog.placeholder": "For example: Level A shows complete understanding while Level B shows partial understanding...",
  "rubricGeneration.differenceDialog.skipAndGenerate": "Skip and Generate",
  "rubricGeneration.differenceDialog.skip": "Skip",
  "rubricGeneration.differenceDialog.completeAndGenerate": "Complete and Generate",
  "rubricGeneration.differenceDialog.next": "Next",
  
  // Report
  "report.noRubricDescriptions": "No rubric descriptions available",
  "report.commentGenerationFailed": "Failed to generate comment",
  "preview.openInNewTab": "Open in new tab",
  "report.generateComment": "Generate Comment",
  "report.pdfGeneration.generating": "Generating PDF",
  "report.pdfGeneration.generatingDescription": "Creating PDF reports for all products...",
  "report.pdfGeneration.step1": "Collecting evaluation data",
  "report.pdfGeneration.step2": "Generating PDF layout",
  "report.pdfGeneration.step3": "Finalizing report",
  "report.backToQuick": "Back to Quick Evaluation",
  "report.generatingPdfDescription": "Generating PDF report. This may take a moment...",
  "report.pdfStep1": "Collecting evaluation data",
  "report.pdfStep2": "Creating PDF layout",
  "report.pdfStep3": "Finalizing report",
  
  // Product Registration
  "productRegistration.error.encryptionError": "Encryption error occurred",
  "productRegistration.quickInput.placeholder": "Enter product names or details (one per line)",
  "productRegistration.quickInput.hint": "You can paste multiple items at once. Empty lines will be ignored.",
  "productRegistration.quickInput.disable": "Switch to detailed input mode",
  "productRegistration.quickInput.enable": "Switch to quick input mode",
  "productRegistration.mode.detailed": "Detailed Mode",
  "productRegistration.mode.quick": "Quick Mode",
  "productRegistration.quickInput.collectDetails": "Collect Details",
  "productRegistration.emptyHint": "Add at least one product to proceed",
  "productRegistration.form.modalTitle": "Edit Product",
  "productRegistration.noDetailProvided": "No details provided",
  "productRegistration.detailsDialog.title": "Product Details",
  "productRegistration.detailsDialog.progress": "Product {{current}} of {{total}}",
  "productRegistration.detailsDialog.productTitle": "{{title}}",
  "productRegistration.detailsDialog.detailLabel": "Details",
  "productRegistration.detailsDialog.detailPlaceholder": "Enter product details or description...",
  "productRegistration.detailsDialog.linkLabel": "Reference Link (optional)",
  "productRegistration.detailsDialog.linkPlaceholder": "https://example.com/product",
  "productRegistration.detailsDialog.hint": "Provide details to help with evaluation. You can skip if not needed.",
  "productRegistration.detailsDialog.skipAndComplete": "Skip All & Complete",
  "productRegistration.detailsDialog.skip": "Skip",
  "productRegistration.detailsDialog.complete": "Complete",
  "productRegistration.detailsDialog.next": "Next",
  
  // Grade Assignment
  "gradeAssignment.distribution.doubleClickToView": "Double-click to view details",
  "gradeAssignment.dragOrDoubleClick": "Drag boundaries or double-click products to adjust",
  
  // Criteria Extraction
  "criteriaExtraction.inputFormTitle": "Evaluation Criteria Input",
  "criteriaExtraction.inputFormSubtitle": "Enter the evaluation criteria for your assessment",
  "criteriaExtraction.productDescriptionsLabel": "Product Descriptions",
  "criteriaExtraction.productDescriptionPlaceholder": "Enter product description...",
  "criteriaExtraction.removeDescription": "Remove description",
  "criteriaExtraction.criteriaListTitle": "Evaluation Criteria List",
  "criteriaExtraction.criterionTitlePlaceholder": "Enter criterion title",
  "criteriaExtraction.criterionDescriptionPlaceholder": "Enter criterion description",
  "criteriaExtraction.addCriterionCard": "Add New Criterion",
  "criteriaExtraction.editCriterion": "Edit criterion",
  "criteriaExtraction.deleteCriterion": "Delete criterion",
  "criteriaExtraction.extracting": "Extracting Criteria",
  "criteriaExtraction.extractingDescription": "Analyzing your input to extract evaluation criteria...",
  "criteriaExtraction.step1": "Analyzing content",
  "criteriaExtraction.step2": "Identifying key criteria",
  "criteriaExtraction.step3": "Organizing results",
  "criteriaExtraction.quickInputPlaceholder": "Enter evaluation criteria or paste content to extract criteria from...",
  "criteriaExtraction.addCriterionModalTitle": "Add New Criterion",
  "criteriaExtraction.criterionTitleLabel": "Criterion Title",
  "criteriaExtraction.criterionDescriptionsLabel": "Criterion Descriptions",
  "criteriaExtraction.removeCriterionDescription": "Remove description",
  "criteriaExtraction.addCriterionDescriptionButton": "Add Description",
  "criteriaExtraction.addCriterionConfirmButton": "Add Criterion",
  
  // Comparative Evaluation Quick
  "comparativeEvaluationQuick.cursor.nextStep": "Proceed to next step",
  "comparativeEvaluationQuick.cursor.nextCriterion": "Proceed to next criterion",
  
  // Dashboard
  "dashboard.enterProjectName": "Enter project name",
  
  // AutoSave
  "autoSave.15seconds": "15 seconds",
  "autoSave.30seconds": "30 seconds",
  "autoSave.1minute": "1 minute",
  "autoSave.2minutes": "2 minutes",
  "autoSave.5minutes": "5 minutes",
  "autoSave.settings": "Auto-save Settings",
  "autoSave.enable": "Enable auto-save",
  "autoSave.interval": "Save interval",
  "autoSave.currentSetting": "Current setting:",
  "autoSave.saveNow": "Save Now",
  "autoSave.saved": "Saved",
  "autoSave.descriptionShort": "Data is saved automatically",
  "autoSave.descriptionLocal": "Also saved to local storage",
  "autoSave.descriptionError": "Data is preserved on error",
  
  // Weight
  "weight.title": "Weight Configuration",
  "weight.description": "Set the importance of each criterion. Adjust so the total equals 100%.",
  "weight.equalDistribution": "Equal Distribution",
  "weight.currentTotal": "Current total:",
  "weight.criterion": "Criterion",
  "weight.weight": "Weight",
  "weight.maxScore": "Max Score",
  "weight.saveSettings": "Save Settings",
  
  // CSV Export
  "csvExport.templateRequired": "Please enter a template",
  "csvExport.exportFailed": "Export failed",
  "csvExport.sampleComment": "This is a sample comment",
  "csvExport.currentUser": "Current user",
  "csvExport.title": "CSV Export",
  "csvExport.exportStatus": "Export Status",
  "csvExport.remaining": "Remaining:",
  "csvExport.unlimited": "Unlimited",
  "csvExport.templateLabel": "Export Template",
  "csvExport.templatePlaceholder": "Enter your template...",
  "csvExport.templateHelp": "Create a template using available variables",
  "csvExport.availablePlaceholders": "Available Variables",
  "csvExport.preview": "Preview",
  "csvExport.filename": "Filename",
  "csvExport.format": "Format",
  "csvExport.includeHeader": "Include Header",
  "csvExport.exporting": "Exporting...",
  
  // Product Registration Import
  "productRegistration.import.sectionTitle": "Import",
  "productRegistration.import.googleDrive": "Google Drive",
  "productRegistration.import.localTitle": "Import from local files",
  "productRegistration.import.localLabel": "Import from local files",
  "productRegistration.import.local": "Local Files",
  
  // Final missing translations
  "productRegistration.import.csvShort": "CSV",
  "productRegistration.export.sectionTitle": "Export",
  "productRegistration.export.template": "Template"
};